/**
 * 推广卡持仓 — GET /api/admin/pcc/holdings
 *
 * Cross-user paginated holdings audit. Operators can filter by `card_id`
 * or `user_id` to audit a single buyer's portfolio or a card's holder
 * roster. Holdings are immutable (purchase, settle, archived) so there is
 * no edit/delete UI.
 */
import { useState } from 'react';
import { Input, Space, Tag } from 'antd';
import { DataTable } from '../../components/DataTable';

interface HoldingRow {
  id: string;
  user_id: number;
  card_id: number;
  card_code: string | null;
  card_title_zh: string | null;
  purchase_price: string;
  earnings: string;
  settle_count: number;
  last_settle_at: string | null;
  create_time: string;
}

export function PccHoldingsPage() {
  const [userId, setUserId] = useState<string>('');
  const [cardId, setCardId] = useState<string>('');

  const columns = [
    {
      title: '持仓 ID',
      dataIndex: 'id',
      width: 120,
      render: (v: string) => v,
    },
    { title: '用户 ID', dataIndex: 'user_id', width: 100 },
    { title: '卡片 ID', dataIndex: 'card_id', width: 100 },
    {
      title: '卡片 Code',
      dataIndex: 'card_code',
      width: 160,
      render: (v: string | null) => v ?? '—',
    },
    {
      title: '卡片标题',
      dataIndex: 'card_title_zh',
      width: 200,
      ellipsis: true,
      render: (v: string | null) => v ?? '—',
    },
    { title: '买入单价 (ORB)', dataIndex: 'purchase_price', width: 140 },
    {
      title: '累计收益 (EP)',
      dataIndex: 'earnings',
      width: 140,
      render: (v: string) => <Tag color="gold">{v}</Tag>,
    },
    {
      title: '结算次数',
      dataIndex: 'settle_count',
      width: 100,
      render: (v: number) => <Tag>{v}</Tag>,
    },
    {
      title: '最近结算',
      dataIndex: 'last_settle_at',
      width: 170,
      render: (v: string | null) => v ?? '—',
    },
    { title: '买入时间', dataIndex: 'create_time', width: 170 },
  ];

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>推广卡持仓</h2>
      <Space style={{ marginBottom: 12 }} wrap>
        <Input
          placeholder="按用户 ID"
          style={{ width: 160 }}
          allowClear
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <Input
          placeholder="按卡片 ID"
          style={{ width: 160 }}
          allowClear
          value={cardId}
          onChange={(e) => setCardId(e.target.value)}
        />
      </Space>
      <DataTable<HoldingRow>
        queryKey={['admin', 'pcc-holdings', userId, cardId]}
        endpoint="/api/admin/pcc/holdings"
        extraParams={{
          user_id: userId ? Number(userId) : undefined,
          card_id: cardId ? Number(cardId) : undefined,
        }}
        columns={columns}
        rowKey="id"
        scroll={{ x: 1500 }}
      />
    </div>
  );
}
